const parseStockCategories = (apiData) => {
  const { data } = apiData;

  return data.map((category) => ({ id: category.id, name: category.name }));
};

export default parseStockCategories;
